module.exports = __webpack_public_path__ + "static/img/surverySurn.aa1be87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surverySurn.png
// module id = j54e
// module chunks = 1